import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mergeAttributes, Node } from '@tiptap/core';
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
function SowAiSectionNodeView() {
    // The "AI-generated" provenance tag stays in the box. The "Updated" (edited) state + its
    // click-to-revert control now live on the SECTION HEADING (the GeneratedSectionBands annotation),
    // so this node only carries the provenance tag + the editable prose.
    return (_jsxs(NodeViewWrapper, { as: "div", className: "sow-ai-section-nodeview", "data-sow-ai-section": "", children: [_jsx("span", { className: "sow-ai-section-nodeview__tags", contentEditable: false, "aria-hidden": "true", children: _jsx("span", { className: "sow-ai-section-nodeview__tag", children: "AI-generated" }) }), _jsx(NodeViewContent, { className: "sow-ai-section-nodeview__content" })] }));
}
export const SowAiSectionNode = Node.create({
    name: 'sowAiSection',
    group: 'block',
    // Holds editable block content (paragraphs / lists), so the user edits the AI prose inline.
    content: 'block+',
    defining: true,
    selectable: false,
    addAttributes() {
        return {
            // The AI section key (e.g. `project_context`); its prose persists to
            // `generationFlags.aiSections[slug]`, never into sowContent.
            slug: { default: '' },
            // The AI's generated text at injection time. GeneratedSectionBands compares the live node
            // text to it (token-stable projection) to show the heading "Updated" revert badge. Not
            // persisted as prose (the node is dropped from sowContent).
            originalText: { default: '' },
        };
    },
    parseHTML() {
        return [{ tag: 'div[data-sow-ai-section]' }];
    },
    renderHTML({ HTMLAttributes }) {
        // Clipboard/export HTML only; never used for sowContent (the serializer drops this node).
        return ['div', mergeAttributes(HTMLAttributes, { 'data-sow-ai-section': '' }), 0];
    },
    addNodeView() {
        return ReactNodeViewRenderer(SowAiSectionNodeView);
    },
});
//# sourceMappingURL=sowAiSectionNode.js.map